import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';

//Api
import cep_api from '../../../api/cep_api';

//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Helpers
import { validarCampos, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

export default function Responsaveis({ pgrss, setPgrss, errors, setErrors, campos }) {
    const [loading, setLoading] = useState(false);
    const onChangePgrss = (e) => {
        const { name, value } = e.target;
        const _pgrss = {
            ...pgrss,
            [name]: value
        }
        const _campo = campos.filter(v => v.name === name);

        const erroCampo = validarCampos(_pgrss, _campo);
        if (erroCampo[1].length > 0) {
            setErrors({ ...errors, ...erroCampo[0] });
        } else {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors({ ..._errors });
        }

        setPgrss(_pgrss);
    }
    //OnBlur para o campo de cep do responsavel legal
    const onBlurCepResponsavelLegal = (e) => {
        const { name, value } = e.target;
        const _endereco = {
            ...pgrss,
            [name]: value
        }
        _endereco.respEstabelecimentoCep = mascaras.cepMask(_endereco.respEstabelecimentoCep, true);
        if (_endereco.respEstabelecimentoCep.length == 8) {
            setLoading(true);
            cep_api.get(_endereco.respEstabelecimentoCep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _endereco.respEstabelecimentoBairro = response.data.bairro;
                _endereco.respEstabelecimentoLogradouro = response.data.logradouro;
                _endereco.respEstabelecimentoCidade = response.data.localidade;
                const _errors = validarCampos(_endereco, campos);
                setErrors({ ..._errors[0] });
                setPgrss({ ..._endereco });
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }
    //OnBlur para o campo de cep do responsavel tecnico pela elaboração do pgrss
    const onBlurCepElaboracaoPGRSS = (e) => {
        const { name, value } = e.target;
        const _endereco = {
            ...pgrss,
            [name]: value
        }
        _endereco.elaboracaoPGRSSCep = mascaras.cepMask(_endereco.elaboracaoPGRSSCep, true);
        if (_endereco.elaboracaoPGRSSCep.length == 8) {
            setLoading(true);
            cep_api.get(_endereco.elaboracaoPGRSSCep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _endereco.elaboracaoPGRSSBairro = response.data.bairro;
                _endereco.elaboracaoPGRSSLogradouro = response.data.logradouro;
                _endereco.elaboracaoPGRSSCidade = response.data.localidade;
                const _errors = validarCampos(_endereco, campos);
                setErrors({ ..._errors[0] });
                setPgrss({ ..._endereco });
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }
    //OnBlur para o campo de cep do responsavel tecnico pelo gerenciamento do pgrss
    const onBlurCepGerenciamentoPGRSS = (e) => {
        const { name, value } = e.target;
        const _endereco = {
            ...pgrss,
            [name]: value
        }
        _endereco.gerenciamentoPGRSSCep = mascaras.cepMask(_endereco.gerenciamentoPGRSSCep, true);
        if (_endereco.gerenciamentoPGRSSCep.length == 8) {
            setLoading(true);
            cep_api.get(_endereco.gerenciamentoPGRSSCep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _endereco.gerenciamentoPGRSSBairro = response.data.bairro;
                _endereco.gerenciamentoPGRSSLogradouro = response.data.logradouro;
                _endereco.gerenciamentoPGRSSCidade = response.data.localidade;
                const _errors = validarCampos(_endereco, campos);
                setErrors({ ..._errors[0] });
                setPgrss({ ..._endereco });
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }
    return (
        <div>
            {loading && <Loading />}
            <h5 className='ms-2 mt-4 mb-3'>Responsável Legal pelo Estabelecimento</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* Nome" name={"respEstabelecimentoNome"} value={pgrss.respEstabelecimentoNome} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoNome} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* E-mail" name={"respEstabelecimentoEmail"} value={pgrss.respEstabelecimentoEmail} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoEmail} />
                    <PrintValidate errors={errors} field={"respEstabelecimentoEmail"} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"20"} label="* Telefone" name={"respEstabelecimentoTelefone"} value={pgrss.respEstabelecimentoTelefone} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoTelefone} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.cepMask} maxLength={"9"} label="* CEP" name={"respEstabelecimentoCep"} onBlur={onBlurCepResponsavelLegal} value={pgrss.respEstabelecimentoCep} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoCep} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Logradouro" name={"respEstabelecimentoLogradouro"} value={pgrss.respEstabelecimentoLogradouro} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoLogradouro} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Bairro" name={"respEstabelecimentoBairro"} value={pgrss.respEstabelecimentoBairro} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoBairro} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Cidade" name={"respEstabelecimentoCidade"} value={pgrss.respEstabelecimentoCidade} onChange={onChangePgrss} invalid={!!errors.respEstabelecimentoCidade} />
                </Col>
            </Row>
            <h5 className='ms-2 mt-4 mb-3'>Responsável Técnico pela Elaboração do PGRSS</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* Nome" name={"elaboracaoPGRSSNome"} value={pgrss.elaboracaoPGRSSNome} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSNome} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* E-mail" name={"elaboracaoPGRSSEmail"} value={pgrss.elaboracaoPGRSSEmail} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSEmail} />
                    <PrintValidate errors={errors} field={"elaboracaoPGRSSEmail"} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"20"} label="* Telefone" name={"elaboracaoPGRSSTelefone"} value={pgrss.elaboracaoPGRSSTelefone} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSTelefone} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Identificação Profissional" name={"elaboracaoPGRSSIdentProfissional"} value={pgrss.elaboracaoPGRSSIdentProfissional} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSIdentProfissional} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Identificação ART" name={"elaboracaoPGRSSART"} value={pgrss.elaboracaoPGRSSART} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSART} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Número Conselho Classe" name={"elaboracaoPGRSSConselhoClasse"} value={pgrss.elaboracaoPGRSSConselhoClasse} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSConselhoClasse} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.cepMask} maxLength={"9"} label="* CEP" onBlur={onBlurCepElaboracaoPGRSS} name={"elaboracaoPGRSSCep"} value={pgrss.elaboracaoPGRSSCep} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSCep} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Logradouro" name={"elaboracaoPGRSSLogradouro"} value={pgrss.elaboracaoPGRSSLogradouro} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSLogradouro} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Bairro" name={"elaboracaoPGRSSBairro"} value={pgrss.elaboracaoPGRSSBairro} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSBairro} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Cidade" name={"elaboracaoPGRSSCidade"} value={pgrss.elaboracaoPGRSSCidade} onChange={onChangePgrss} invalid={!!errors.elaboracaoPGRSSCidade} />
                </Col>
            </Row>
            <h5 className='ms-2 mt-4 mb-3'>Responsável Técnico pelo Gerenciamento do PGRSS</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* Nome" name={"gerenciamentoPGRSSNome"} value={pgrss.gerenciamentoPGRSSNome} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSNome} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label="* E-mail" name={"gerenciamentoPGRSSEmail"} value={pgrss.gerenciamentoPGRSSEmail} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSEmail} />
                    <PrintValidate errors={errors} field={"gerenciamentoPGRSSEmail"} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"20"} label="* Telefone" name={"gerenciamentoPGRSSTelefone"} value={pgrss.gerenciamentoPGRSSTelefone} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSTelefone} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Identificação Profissional" name={"gerenciamentoPGRSSIdentProfissional"} value={pgrss.gerenciamentoPGRSSIdentProfissional} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSIdentProfissional} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Identificação ART" name={"gerenciamentoPGRSSART"} value={pgrss.gerenciamentoPGRSSART} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSART} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label="* Número Conselho Classe" name={"gerenciamentoPGRSSConselhoClasse"} value={pgrss.gerenciamentoPGRSSConselhoClasse} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSConselhoClasse} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.cepMask} maxLength={"9"} label="* CEP" onBlur={onBlurCepGerenciamentoPGRSS} name={"gerenciamentoPGRSSCep"} value={pgrss.gerenciamentoPGRSSCep} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSCep} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Logradouro" name={"gerenciamentoPGRSSLogradouro"} value={pgrss.gerenciamentoPGRSSLogradouro} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSLogradouro} />
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Bairro" name={"gerenciamentoPGRSSBairro"} value={pgrss.gerenciamentoPGRSSBairro} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSBairro} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label="* Cidade" name={"gerenciamentoPGRSSCidade"} value={pgrss.gerenciamentoPGRSSCidade} onChange={onChangePgrss} invalid={!!errors.gerenciamentoPGRSSCidade} />
                </Col>
            </Row>
        </div>
    )
}